<template>
  <section>
    <footer>
      <ul class="footer-menu">
        <li>
          <router-link :to="{path:'/'}">
            <i class="home"></i>
            <span>首页</span>
          </router-link>
        </li>
        <collect :type="type" :resource-id="resourceId"/>
        <share-button :share-data="shareData"/>
      </ul>
      <slot></slot>
    </footer>
  </section>
</template>

<script>
import share from '@/components/share.vue'
import ShareButton from '@/components/shareButton.vue'
import Collect from '@/components/collect.vue'
export default {
  name: 'detail-footer',
  components: {
    share,
    ShareButton,
    Collect
  },
  props: {
    type: {
      type: String,
      required: true
    },
    resourceId: {
      type: [String, Number],
      required: true
    },
    shareData: {
      type: Object
    }
  },
  data() {
    return {}
  },
  methods: {
    onShow() {
      this.shareShow.isShow = true
    },
    hasSlotContent() {
      return this.$slots
    }
  }
}
</script>

<style lang="less">
footer {
  width: 100%;
  height: 98 / @rem-size;
  background: #fff;
  box-shadow: 0 0 18 / @rem-size 0 rgba(208, 208, 208, 0.2);
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 8 / @rem-size 46 / @rem-size 0;
  z-index: 888;

  ul {
    display: flex;
    justify-content: space-between;

    li {
      &:active {
        opacity: 0.8;
      }

      span {
        display: block;
        color: #999;
        font-size: 24 / @rem-size;
        margin-top: 8 / @rem-size;
      }
    }
  }
}
</style>
